import { FC } from 'react'
import { Col, Row } from 'react-grid-system'
import styled from 'styled-components'
import { ContractDetailCard } from './ContractInfoCard'
import { PaymentAndBillingInfoCard } from '../molecules'

const Wrapper = styled.div`
  
`

export const ContractDetailsInfoCard: FC = () => {
  return (
    <Wrapper>
      <Row>
        <Col>
          <h1>Contract Detail</h1>
        </Col>
      </Row>
      <Row>
        <Col>
          <ContractDetailCard 
            property="El chulengo"
            unit="9b"
            location="Manzanres 1980"
            contractTerm='25 de mayo del 2027'
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <PaymentAndBillingInfoCard
            rent={800}
            deposit={800}
            lateFee={0}
          />
        </Col>
      </Row>
    </Wrapper>
  )
}